export const getSustainabilityIndexByMonthlyRateAndDeposit = (monthlyRateMax, offerMonthlyRate, depositRequired, offerDeposit, thresholdMonthlyRateMax) => {
    if ((!depositRequired || offerDeposit > 0) && offerMonthlyRate <= monthlyRateMax) {
        return 2;
    }

    if (
        (depositRequired === false || offerDeposit > 0)
        && offerMonthlyRate <= (thresholdMonthlyRateMax * 1.1)
    ) {
        return 1;
    }

    if (
        depositRequired === true && offerDeposit === 0
        && offerMonthlyRate <= monthlyRateMax
    ) {
        return 1;
    }

    return 0;
}

export const getSustainabilityMessageByMonthlyRateAndDeposit = (monthlyRateMax, offerMonthlyRate, depositRequired, offerDeposit, thresholdMonthlyRateMax) => {
    if ((!depositRequired || offerDeposit > 0) && offerMonthlyRate <= monthlyRateMax) {
        return 'CONGRATULATIONS_THIS_OFFER';
    }

    if (
        (depositRequired === false || offerDeposit > 0)
        && offerMonthlyRate <= (thresholdMonthlyRateMax * 1.1)
    ) {
        return 'MONTHLY_RATE_TRASHOLD';
    }

    if (
        depositRequired === true && offerDeposit === 0
        && offerMonthlyRate <= monthlyRateMax
    ) {
        return 'NEED_DEPOSIT';
    }

    return 'TOO_MUCH_MONTHLY_RATE';
}
